const getUrlParam = (param) => {
  return new URLSearchParams(window.location.search).get(param);
};
export default getUrlParam;
